import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ReservationPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    people: 1,
    tableType: "Hibachi Table",
    kids: "No",
    note: "",
    date: new Date(),
    time: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleDateChange = (date) => {
    setFormData({
      ...formData,
      date,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Reservation confirmed for ${formData.name} on ${formData.date.toLocaleDateString()} at ${formData.time}!`);
    setFormData({
      name: "",
      phone: "",
      people: 1,
      tableType: "Hibachi Table",
      kids: "No",
      note: "",
      date: new Date(),
      time: ""
    });
  };

  return (
    <div className="container-fluid reservation-page py-5">
      <div className="row align-items-center">
        {/* Left Side: Form */}
        <div className="col-lg-7 p-5">
          <h2 className="text-uppercase fw-bold mb-3">
            Reserve a <span className="text-danger">Table</span>
          </h2>
          <p className="mb-4 text-muted">
            Make an online reservation at our Hibachi Restaurant.
          </p>
          <form onSubmit={handleSubmit} className="p-4 shadow-lg bg-white rounded">
            <div className="mb-3">
              <label className="form-label">Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="form-control"
                placeholder="Your Full Name"
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Phone Number</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="form-control"
                placeholder="(123) 456-7890"
                required
              />
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Date</label>
                <DatePicker
                  selected={formData.date}
                  onChange={handleDateChange}
                  className="form-control"
                  minDate={new Date()}
                  dateFormat="MMMM d, yyyy"
                  required
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Time</label>
                <input
                  type="time"
                  name="time"
                  value={formData.time}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label">How Many People?</label>
              <input
                type="number"
                name="people"
                value={formData.people}
                onChange={handleChange}
                className="form-control"
                min="1"
                max="20"
                required
              />
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Table Type</label>
                <select
                  name="tableType"
                  value={formData.tableType}
                  onChange={handleChange}
                  className="form-select"
                >
                  <option value="Hibachi Table">Hibachi Table</option>
                  <option value="Regular Table">Regular Table</option>
                </select>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Any Kids?</label>
                <select
                  name="kids"
                  value={formData.kids}
                  onChange={handleChange}
                  className="form-select"
                >
                  <option value="No">No</option>
                  <option value="Yes">Yes</option>
                </select>
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label">Additional Notes</label>
              <textarea
                name="note"
                value={formData.note}
                onChange={handleChange}
                className="form-control"
                placeholder="Any special requests?"
                rows="3"
              ></textarea>
            </div>
            <button type="submit" className="btn btn-danger w-100 py-2">
              Confirm Reservation
            </button>
          </form>
        </div>

        {/* Right Side: Image */}
        <div className="col-lg-5 d-none d-lg-block p-0">
          <img
            src="https://media.istockphoto.com/id/1630278915/photo/chef-cooking-in-japanese-teppanyaki-restaurant.jpg?s=612x612&w=0&k=20&c=zmEHA4vafutq7BhwAqdClldJ3j6dXjZzFYKyYd4WO00="
            alt="Hibachi Chef Cooking"
            className="img-fluid w-100 h-100 object-fit-cover"
          />
        </div>
      </div>
    </div>
  );
};

export default ReservationPage;
